import { render, staticRenderFns } from "./x-dialog.vue?vue&type=template&id=c48afd34"
import script from "./x-dialog.vue?vue&type=script&lang=ts"
export * from "./x-dialog.vue?vue&type=script&lang=ts"
import style0 from "./x-dialog.vue?vue&type=style&index=0&id=c48afd34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports